import { useNavigate } from "react-router-dom";
import { gbp, ukDate } from "../lib/format";
import { PotBadge, StatusBadge } from "./common";
import { useAuth } from "../context/AuthContext";

const pct = (v) => (v == null ? "Not set" : `${Math.round(v * 1000) / 10}%`);

const COLS = [
  ["proforma_equity", "Equity requirement (proforma)"], ["current_equity", "Equity requirement (current)"], ["deployed", "Equity deployed"],
  ["to_deploy", "Equity to deploy"], ["equity_return", "Equity return"], ["profit", "Profit"],
];

export function ProjectsTable({ rows, totals, showPartner = true, showSplitCols = true }) {
  const navigate = useNavigate();
  const { isPartner } = useAuth();
  const th = "px-3 py-2.5 text-xs font-semibold text-muted-foreground whitespace-nowrap";
  const td = "px-3 py-2.5 whitespace-nowrap";
  const totalRow = (pos) => (
    <tr className={`bg-muted font-bold ${pos === "top" ? "border-b" : "border-t"}`} data-testid={`projects-totals-row-${pos}`}>
      <td className={`${td} font-heading`} colSpan={isPartner ? (showPartner ? 5 : 4) : (showPartner ? 8 : 7)}>Totals · <span data-testid={`projects-totals-count-${pos}`}>{totals.count}</span> projects</td>
      {COLS.map(([k]) => <td key={k} className={`${td} text-right font-figure`} data-testid={`total-${k}-${pos}`}>{gbp(totals[k])}</td>)}
    </tr>
  );
  return (
    <div className="overflow-auto rounded-lg border bg-card grid-scroll max-h-[70vh]">
      <table className="dt dt-sticky w-full text-sm" data-testid="projects-table">
        <thead className="sticky top-0 z-10 bg-card shadow-[0_1px_0_hsl(var(--border))]">
          <tr className="text-left">
            {showPartner && <th className={th}>Partner</th>}
            <th className={th}>Project</th><th className={th}>SPV</th>
            {isPartner ? null : <><th className={th}>Pot</th><th className={th}>Share</th><th className={th}>Owner</th></>}
            <th className={th}>Proforma date</th><th className={th}>Status</th>
            {COLS.map(([k, l]) => <th key={k} className={`${th} text-right`}>{l}</th>)}
          </tr>
        </thead>
        <tbody>
          {totalRow("top")}
          {rows.map((r) => (
            <tr key={r.id} onClick={() => navigate(`/projects/${r.id}`)} data-testid={`project-row-${r.ref}`}
              className={`cursor-pointer border-b transition-colors hover:bg-accent/60 ${r.include ? "" : "opacity-50"}`}>
              {showPartner && <td className={`${td} text-muted-foreground`}>{r.partner_name}</td>}
              <td className={`${td} max-w-[280px] truncate font-semibold`} title={r.name} data-testid="project-name-cell">{r.name}</td>
              <td className={`${td} max-w-[180px] truncate text-muted-foreground`} title={r.spv || ""}>{r.spv || "–"}</td>
              {isPartner ? null : <><td className={td}><PotBadge pot={r.metrics.pot} /></td><td className={`${td} text-xs`} data-testid={`pot-share-${r.id}`}>{r.epil_share ? `${r.epil_share.label} ${r.epil_share.pct == null ? "Not set" : pct(r.epil_share.pct)}` : ""}</td><td className={`${td} text-xs`}>{r.owner_code}</td></>}
              <td className={`${td} text-xs`}>{ukDate(r.proforma_signed)}</td>
              <td className={td}><StatusBadge status={r.status} /></td>
              {COLS.map(([k]) => <td key={k} className={`${td} text-right font-figure`}>{gbp(r.metrics[k])}</td>)}
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan={14} className="px-3 py-10 text-center text-muted-foreground" data-testid="projects-empty">No projects match these filters</td></tr>
          )}
          {rows.length > 0 && totalRow("bottom")}
        </tbody>
      </table>
    </div>
  );
}
